// @ actions
const signaturePatternActions = require('actions/signaturePattern');
const hireCardImageSelectorActions = require('actions/hireCardImageSelector');
const hireCardNameSelectorActions = require('actions/hireCardNameSelector');
const hireInformationActions = require('actions/hireInformation');
const { updateConsents } = require('actions/gdprConsents');
const hireContactDataActions = require('actions/hireContactData');
const { setShippingAddress, resetShippingAddress } = require('actions/shippingAddress');
const { resetPreContractualInfo } = require('actions/preContractualInfo');
const { setTermsAndCondsInfo } = require('actions/termsAndCondsInfo');

// @ utilities
const { APIPost } = require('utilities/APIRequestHelper');
const { scrollToTop } = require('commonsUtilities/scrollUtils');
const {
  getDebitCardHiringStatus,
  getShippingAddressDetails,
} = require('utilities/hireCardsHelper');

// @ constants
const actionTypes = require('constants/actionTypes');
const { API_CENTER, API_ENTERPRISE_NUMBER, SECOND_STEP } = require('constants/index');
const { NEW_SHIPPING_ADDRESS } = require('constants/shippingAddress');
const {
  MAESTRO_CARD_PRODUCT_ALIAS,
  MAESTRO_CARD_PRODUCT_MIN_ALIAS,
} = require('constants/hiringProductInformation');
const { MESSAGE_HIRE_24H } = require('constants/flagBasedFeatures');

function resetWizard() {
  return {
    type: actionTypes.HIRE_CARD_MAESTRO_RESET,
  };
}

const reset = () => dispatch => {
  dispatch(hireCardImageSelectorActions.reset());
  dispatch(hireCardNameSelectorActions.reset());
  dispatch(hireInformationActions.reset());
  dispatch(hireContactDataActions.reset());
  dispatch(resetShippingAddress());
  dispatch(resetWizard());
  dispatch(resetPreContractualInfo());
};

function setAccount(accountId) {
  return {
    type: actionTypes.HIRE_CARD_MAESTRO_SET_ACCOUNT,
    payload: {
      accountId,
    },
  };
}

function setAgreementCheckbox(evt) {
  return {
    type: actionTypes.HIRE_CARD_MAESTRO_SET_AGREEMENT_CHECKBOX,
    payload: {
      checked: evt.target.checked,
    },
  };
}

function setVisibleStep(step) {
  return {
    type: actionTypes.HIRE_CARD_MAESTRO_SET_VISIBLE_STEP,
    payload: {
      step,
    },
  };
}

function validateLoading(loadingFlag) {
  return {
    type: actionTypes.HIRE_CARD_LOADING,
    payload: {
      loadingFlag,
    },
  };
}

function validate(step, externalComponentsAreValid) {
  return {
    type: actionTypes.HIRE_CARD_MAESTRO_VALIDATE_STEP,
    payload: {
      step,
      valid: externalComponentsAreValid,
    },
  };
}

const getStep = step => (dispatch, getState) => {
  const valid = getState().hireCardMaestro.getIn(['steps', step - 1, 'valid']);
  if (!valid) {
    scrollToTop();
  }
  return valid;
};

const validateThirdStep = step => (dispatch, getState) => {
  const immShippingAddress = getState().shippingAddress;
  const shippingAddressType = immShippingAddress.get('shippingAddressType');
  let allComponentsAreValid = true;

  if (shippingAddressType === NEW_SHIPPING_ADDRESS) {
    //Send param false in validateStep to show absence of mobile field
    dispatch(hireContactDataActions.validateStep(false));
    const immHireContactData = getState().hireContactData;
    allComponentsAreValid = immHireContactData.get('isValid');

    dispatch(validate(step, allComponentsAreValid));
    //Set shipping address as new correspondance address
    allComponentsAreValid && dispatch(setShippingAddress(NEW_SHIPPING_ADDRESS, immHireContactData));
  } else {
    dispatch(validate(step, allComponentsAreValid));
  }
};
const validateBlockedAccount = () => (dispatch, getState) => {
  const accountsById = getState().accounts.get('byId');
  const contracto = accountsById.map(account => {
    return { numerodecontrato: account.get("newContractNumber"), producto: account.get("newProduct") }
  });
  const requestData = {
    query: {
      accounts: Object.values(contracto.toJS())
    }
  };
  return APIPost({
    dispatch,
    endpoint: 'validateBlockedAccount',
    params: requestData
  })
    .then(() => {
      return true
    })
    .catch(response => {
      if (!!response.error) {
        dispatch(hireCardMaestroFailure(''));
        dispatch(validateLoading(false));
      } else {
        throw response;
      }
    });
}
const validateStep = step => (dispatch, getState) => {
  dispatch(validateBlockedAccount())

  if (step === 3) {
    dispatch(validateThirdStep(step));
  } else if (step === 1 && getState().flagBasedFeatures.get(MESSAGE_HIRE_24H)) {
    const immCards = getState().cards;
    const immCardById = immCards && immCards.get('byId');
    const immCardByOrder = immCards && immCards.get('byOrder');

    const cardObj =
      immCardByOrder &&
      immCardByOrder.map(cardId => {
        const immCard = immCardById && immCardById.get(cardId);
        return {
          contractNumber: immCard.getIn(['contract', 'number']),
          pan: immCard.get('number'),
          product: immCard.get('newProduct'),
          subType: immCard.get('productSubType'),
          standard: immCard.getIn(['product', 'standard']),
        };
      });
    dispatch(validateLoading(true));
    return APIPost({
      dispatch,
      endpoint: 'validateCardHire',
      params: {
        query: { cards: cardObj },
      },
    })
      .then(() => {
        dispatch(validateLoading(false));
        dispatch(validate(step, false));
      })
      .catch(error => {
        if (error) {
          if (error.error.status === 412 && error.body.error === 'HIRE_BLOCKED') {
            dispatch(validate(step, true));
            dispatch(validateLoading(false));
          } else {
            dispatch(hireCardMaestroFailure(''));
            dispatch(validateLoading(false));
          }
        }
      });
  } else {
    dispatch(validateLoading(false));
    dispatch(validate(step, false));
  }
  return dispatch(getStep(step));
};

function setWillCancel(willCancel) {
  return {
    type: actionTypes.HIRE_CARD_MAESTRO_WILL_CANCEL,
    payload: {
      willCancel,
    },
  };
}

const hireCardMaestroRequest = () => ({
  type: actionTypes.HIRE_CARD_MAESTRO_REQUEST,
});

const hireCardMaestroSuccess = response => ({
  type: actionTypes.HIRE_CARD_MAESTRO_SUCCESS,
  payload: {
    response,
  },
});

const hireCardMaestroFailure = errorMsg => ({
  type: actionTypes.HIRE_CARD_MAESTRO_FAILURE,
  payload: {
    errorMsg,
  },
});

const setAllAccountsToInactive = () => ({
  type: actionTypes.HIRE_CARD_MAESTRO_SET_ALL_ACCOUNTS_TO_INACTIVE,
});

const setCardMaestro = (dispatch, data, termsAndsCondsHiringData) => {
  const requestData = {
    header: {
      version: 2,
    },
    query: data,
  };

  dispatch(hireCardMaestroRequest());

  return APIPost({
    dispatch,
    endpoint: 'hireMaestroCardDebit',
    params: requestData,
  })
    .then(response => {
      const status = getDebitCardHiringStatus(response);

      if (status.error) {
        dispatch(hireCardMaestroFailure(status.errorMsg));
      } else {
        dispatch(hireCardMaestroSuccess(response));
        dispatch(setTermsAndCondsInfo(MAESTRO_CARD_PRODUCT_ALIAS, termsAndsCondsHiringData));
      }
    })
    .catch(response => {
      const status = getDebitCardHiringStatus(response);
      if (status.error) {
        dispatch(hireCardMaestroFailure(status.errorMsg));
      } else if (!!response.error) {
        dispatch(hireCardMaestroFailure(''));
      } else {
        throw response;
      }
    });
};

const hireCardMaestro = () => (dispatch, getState) => {
  const callback = (dispatch, getState, dataToken) => {
    const accountId = getState().hireCardMaestro.getIn(['steps', SECOND_STEP, 'accountId']);
    const immAccount = getState().accounts.getIn(['byId', accountId]);
    const immShippingAddress = getState().shippingAddress;
    const shippingAddressType = immShippingAddress.get('shippingAddressType');
    const immHireCardNameSelector = getState().hireCardNameSelector;
    const selectedName = immHireCardNameSelector.getIn([
      'names',
      immHireCardNameSelector.get('selectedIndex'),
    ]);
    let addressDetails = null;
    let numDomicilio = null;

    if (shippingAddressType === NEW_SHIPPING_ADDRESS) {
      const immContactData = getState().hireContactData;
      addressDetails = getShippingAddressDetails(immContactData);
    } else {
      numDomicilio = immShippingAddress.getIn(['shippingAddress', 'numDomicilio']);
    }

    const data = {
      addressDetails: addressDetails,
      cardDetails: {
        cuentaCargo: `${API_ENTERPRISE_NUMBER}${API_CENTER}${immAccount.get(
          'product'
        )}${immAccount.get('contractNumber')}`,
        //TODO: To be replace with actual data once get approved
        nombreAdicional: '',
        nombreBeneficiario: selectedName,
      },
      dataToken,
      numDomicilio,
      deliverToProvidedDetails: true,
    };

    const termsAndsCondsHiringData = [
      {
        passportProductId: MAESTRO_CARD_PRODUCT_MIN_ALIAS,
      },
    ];

    dispatch(updateConsents(dataToken))
      .then(() => setCardMaestro(dispatch, data, termsAndsCondsHiringData))
      .catch(response => {
        if (!!response.error) {
          setCardMaestro(dispatch, data, termsAndsCondsHiringData);
        } else {
          throw response;
        }
      });
  };

  new Promise(() => {
    signaturePatternActions.validateAndExecute(dispatch, getState, callback);
  });
};

module.exports = {
  hireCardMaestro,
  reset,
  setAccount,
  setAgreementCheckbox,
  setAllAccountsToInactive,
  setVisibleStep,
  setWillCancel,
  validateStep,
};
